export default __webpack_public_path__ + "static/media/save-white.344d2131.svg";